document.addEventListener("DOMContentLoaded", function () {

  const hero = document.querySelector(".tec-hero");
  if (!hero) return;

  if (window.innerWidth > 768) {

    hero.addEventListener("mousemove", function (e) {

      const moveX = (e.clientX / window.innerWidth - 0.5) * 12;
      const moveY = (e.clientY / window.innerHeight - 0.5) * 12;

      hero.style.backgroundPosition =
      `calc(50% + ${moveX}px) calc(50% + ${moveY}px)`;

    });

  }

});